import { makeStyles } from "@material-ui/core/styles";

export const useInfoComponentStyles = makeStyles((theme) => ({
  doctorAtLeft: {
    [theme.breakpoints.down("sm")]: {
      height: "40vh",
    },
    position: "fixed",
    bottom: 0,
    zIndex: 15,
    left: 0,
    transform: "scaleX(-1)",
    height: "50vh",
  },
  doctorAtRight: {
    [theme.breakpoints.down("sm")]: {
      height: "40vh",
    },
    right: 0,
    position: "fixed",
    bottom: 0,
    zIndex: 15,
    height: "57vh",
  },
  canvas: {
    position: "fixed",
    overflowY: "auto",
    width: "100vw",
    height: "100vh",
    backgroundColor: "black",
    opacity: "0.6",
    objectFit: "cover",
    zIndex: 11,
    top: 0,
    left: 0,
  },
  background: {
    zIndex: 14,
    width: "100%",
    height: "100%",
    top: 0,
    position: "fixed",
    objectFit: "cover",
    left: 0,
  },
  cross: {
    display: "flex",
    justifyContent: "flex-end",
    height: 50,
  },
  close: {
    width: "25px",
    height: "25px",
    cursor: "pointer",
    color: "red",
  },
  proceed: {
    marginTop: 35,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 17,
      marginTop: 20,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
      marginTop: 10,
    },
  },
  textContainer: {
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
    },
    marginTop: 10,
    paddingRight: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  contents: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  image: {
    width: "100%",
    height: 55,
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-3%",
      marginTop: 10,
      width: "105%",
    },
  },
  text: {
    fontSize: 17,
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 13,
    },
  },
  hideDoctor: {
    display: "none",
  },
  commonCard: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "23%",
      width: "55%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      width: "85%",
      marginLeft: "10%",
    },
    marginTop: "32vh",
    paddingBottom: theme.spacing(0.2),
  },
  cardAtBottomSmall: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "23%",
      width: "55%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "60vh",
      width: "80%",
      marginLeft: "10%",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "7vh",
      width: "85%",
      marginLeft: "10%",
    },
    marginTop: "32vh",
    paddingBottom: theme.spacing(0.2),
  },
  cardLeftSmall: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "15%",
      width: "40%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "9vh",
      width: "78%",
      marginLeft: "10%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    marginTop: "19vh",
    paddingBottom: theme.spacing(0.2),
  },
  cardAtBottom: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "40vh",
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "50vh",
      width: "80%",
      marginLeft: "10%",
    },
    marginTop: "43vh",
    marginBottom: "5%",
    paddingBottom: theme.spacing(0.2),
  },
  cardAtBottomTop: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "7vh",
      width: "85%",
      marginLeft: "10%",
    },
    marginTop: "46vh",
    marginBottom: "5%",
    paddingBottom: theme.spacing(0.2),
  },
  cardAtBottomEvaluation: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "40vh",
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "60vh",
      width: "80%",
      marginLeft: "10%",
    },
    marginTop: "43vh",
    marginBottom: "5%",
    paddingBottom: theme.spacing(0.2),
  },
  cardBottomUp: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "40vh",
      marginLeft: "20%",
      width: "60%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "9vh",
      width: "85%",
      marginLeft: "10%",
    },
    marginTop: "43vh",
    marginBottom: "5%",
    paddingBottom: theme.spacing(0.2),
  },
  cardRightUp: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "40%",
      width: "45%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      width: "85%",
      marginLeft: "10%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    marginTop: "10vh",
    paddingBottom: theme.spacing(0.2),
  },
  cardRightDown: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "40%",
      marginTop: "10vh",
      width: "45%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "60vh",
      width: "80%",
      padding: theme.spacing(2, 2, 2, 3),
      marginLeft: "10%",
    },
    paddingBottom: theme.spacing(0.2),
  },
  cardRightDown2: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "40%",
      marginTop: "20vh",
      width: "45%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "60vh",
      width: "80%",
      padding: theme.spacing(2, 2, 2, 3),
      marginLeft: "10%",
    },
    paddingBottom: theme.spacing(0.2),
  },
  cardBottomRight: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "45%",
      marginTop: "40vh",
      width: "45%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "50vh",
      width: "80%",
      padding: theme.spacing(2, 2, 2, 3),
      marginLeft: "10%",
    },
    paddingBottom: theme.spacing(0.2),
  },
  cardLeft: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "3%",
      width: "40%",
      padding: theme.spacing(2, 2, 2, 3),
      marginBottom: 50,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "3%",
      width: "40%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      width: "85%",
      marginLeft: "5%",
    },
    marginTop: "10vh",
    paddingBottom: theme.spacing(0.2),
  },
  cardLeftDown: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "3%",
      width: "40%",
      padding: theme.spacing(2, 2, 2, 3),
      marginBottom: 50,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "3%",
      width: "43%",
      padding: theme.spacing(2, 2, 2, 3),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "50vh",
      width: "80%",
      padding: theme.spacing(2, 2, 2, 3),
      marginLeft: "10%",
    },
    marginTop: "10vh",
    paddingBottom: theme.spacing(0.2),
  },
}));
